module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.screen_loading),
      expression: "screen_loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "wrap-list"
  }, [_c('div', {
    staticClass: "title-btn"
  }, [_c('span', {
    staticClass: "title-back",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "title-doc"
  }, [_vm._v(_vm._s(_vm.folderName))]), _vm._v(" "), (_vm.type == 'tpl' && _vm.userInfo.buIdentityType == 1) ? _c('div', {
    staticClass: "front-btn green"
  }, [_c('input', {
    attrs: {
      "id": "doc",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        _vm.uploadFile($event)
      }
    }
  }), _vm._v("上传\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('div', {
    staticClass: "head"
  }, _vm._l((_vm.list.headtext), function(text, index) {
    return _c('div', {
      key: text
    }, [_vm._v(_vm._s(index == 0 && _vm.type == "doc" ? "文档编号" : text))])
  })), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "detail"
  }, [_vm._l((_vm.listData), function(lists) {
    return _c('div', {
      key: lists.id,
      staticClass: "list-item"
    }, [_c('div', [_vm._v(_vm._s(lists.code))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("justDate")(lists.created_at)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(lists.real_name))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": lists.doc_name || lists.tpl_doc_name
      }
    }, [_vm._v(_vm._s(lists.doc_name || lists.tpl_doc_name))]), _vm._v(" "), _c('div', [_c('a', {
      on: {
        "click": function($event) {
          _vm.downloadFile(lists.id)
        }
      }
    }, [_vm._v("下载")]), _vm._v(" "), (_vm.type == 'tpl' && lists.tpl_doc_type == 2 && lists.user_id == _vm.userInfo.id) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.del(lists.id)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.listData
    }
  })], 2)], 1)]), _vm._v(" "), _c('z-pagination', {
    attrs: {
      "data": _vm.data
    },
    on: {
      "getPage": _vm.refresh
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1e86ec52!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/documentManage/page-docList.vue
// module id = 705
// module chunks = 1